import { BaseComponentConfig } from '@interfaces/config/cms-components/base-config';
import { CmsComponentTypeEnum } from '@models/enums';
import { TextMediaBox } from '@interfaces/config';

export namespace LogoSlider {
  export const TypeEnum = CmsComponentTypeEnum.LOGO_SLIDER;

  
  export interface ComponentConfig extends BaseComponentConfig {
    columns: TextMediaBox.MediaImageConfig[];
    sliderImages: any[],
    anchor_id?:string
  }
}
